export const CHANGE_ADDRESS = 'location.changeAddress';
export const CLOSE_LOCATIONS_LIST = 'location.closeLocationsList';
export const ENABLE_ADDRESS_EDIT = 'location.enableAddressEdit';
export const OPEN_LOCATIONS_LIST = 'location.openLocationsList';
export const RESET_STATE = 'location.resetState';
export const SAVE_LOCATION = 'location.saveLocation';
export const SELECT_LOCATION = 'location.selectLocation';
export const UPDATE_SEARCH_RESULTS = 'location.updateSearchResults';
